export { AboutHero } from '@/components/about/about-hero'
export { AboutSlider } from '@/components/about/about-slider'
export { Philosophy } from '@/components/about/philosophy'
export { Testimonials } from '@/components/about/testimonials'
export { Faq } from '@/components/about/faq'
export { GoldenCta } from '@/components/about/golden-cta'
